import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TechnologyDetails {
  loading: boolean;
  data: [];
  status: number;
  // error:null| string
}

export const initialState: TechnologyDetails = {
  loading: false,
  data: [],
  status: 0,
  // error:null
};

const domainListSlice = createSlice({
  name: "domainList",
  initialState,
  reducers: {
    domainListRequest(state: TechnologyDetails) {
      state.loading = true;
    },
    domainListSuccess(
      state: TechnologyDetails,
      action: PayloadAction<{ data: any; status: number }>,
    ) {
      state.loading = false;
      state.data = action.payload.data;
      state.status = action.payload.status;
    },
    domainListFailure(state: TechnologyDetails) {
      state.loading = false;
      // state.error = action.payload;
    },
  },
});

export const domainListAction = domainListSlice.actions;
export const domainListReducer = domainListSlice.reducer;

export default domainListReducer;
